import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { InfluencerInfoRdo, QueryResponse } from '@/models';
import { FindInfluencerByIdQuery } from '@/apis/feature/influencer';
import InfluencerSeekApi from '@/apis/feature/adm/influencer/rest/InfluencerSeekApi.ts';

export const useInfluencerDetail = (influencerId: number) => {
  //
  const query: FindInfluencerByIdQuery = {
    influencerId,
  };

  const { data, isLoading, error, refetch }: UseQueryResult<QueryResponse<InfluencerInfoRdo>> = useQuery({
    queryKey: ['InfluencerSeekApi', 'findInfluencerDetail', influencerId],
    queryFn: () => InfluencerSeekApi.findInfluencerDetail(query),
    enabled: !!influencerId && influencerId > 0,
  });

  const influencerInfo = data?.result;

  return {
    influencerInfo,
    isLoading,
    error,
    refetchInfluencerDetail: refetch,
  };
};
